import TemplateStyleViewModelT from '@/ViewModels/Views/TemplateStyleViewModel';
import ViewFactory from '@/Factories/ViewFactory';
import ComponentManager from '@/Management/ComponentManager';
export default class TemplateStyleViewFactory extends ViewFactory {
    public viewModel: any;
    public view: any;
    private TemplateStyleViewModel: any;
    private TemplateStyleView: any;
    constructor(params: any) {
        super(params);
        this.TemplateStyleViewModel = ComponentManager.getViewModel<typeof TemplateStyleViewModelT>('TemplateStyleViewModel');
        this.TemplateStyleView = ComponentManager.getView('TemplateStyleView');
    }
    public getRegion(): string {
        return 'Modal';
    }
    public shouldReplaceRegion(): boolean {
        return true;
    }
    public getView(): any {
        if (this.viewModel == null) {
            this.viewModel = new this.TemplateStyleViewModel({ viewFactory: this });
        }
        if (this.view == null) {
            this.view = new this.TemplateStyleView(this.viewModel, this.createRootElement('TemplateStyle'));
        }
        let tuple = this.view.getTuple();
        return tuple.view;
    }
    public getNecessaryRedirect(): any {
        return false;
    }
}

ComponentManager.setFactory('TemplateStyle', TemplateStyleViewFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setFactory('TEMPLATE_STYLE', TemplateStyleViewFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');